import EZO	from "./circuits/ezo.js";

class DissolvedOxygenSensor extends EZO {
  constructor(p) {
    super(0x61);

    this.id = "-";
    this.value = "-";
    this.status = "uninitialized";
    this.calibrationStatus = "-";
    this.temperatureCompensationStatus = "-";
    this.internalTemperature = "N/A";
  }
  async initialize() {
    try {
      await super.initialize();
      this.id = await this.command("i");
      await this.command("O,mg,0");
      await this.command("O,%,1");
      this.status = "ok";
    } catch(e) {
      this.status = "failed";
      throw e;
    }
  }
  update(devices) {
    /* 
      from firmware version 2.13 we can use the RT command:
      RT,n set temperature compensation and take a reading

      //await this.command(`T,${devices.temperatureSensor.value?devices.temperatureSensor.value:25}`);
      //this.value = await this.command("R");
    */
    
    return( new Promise(function(resolve, reject) {
      this.command(`T,${devices.temperatureSensor.value?devices.temperatureSensor.value:25}`).then(function(result) {
        return this.command("T,?");
      }.bind(this)).then(function(result) {
        this.temperatureCompensationStatus = result;
        return this.command("Cal,?");
      }.bind(this)).then(function(result) {
        this.calibrationStatus = result;
        return this.command("R");
      }.bind(this)).then(function(result) {
        this.value = parseFloat(result);
        resolve(this.value);
      }.bind(this)).catch(function(result) {
        reject(result);
      }.bind(this));
    }.bind(this)) );
  }
  clearCalibration() {
    return this.command("Cal,clear");
  }
  calibrateTo0() {
    return this.command("Cal,0");
  }
  calibrateTo21() {
    return this.command("Cal");
  }
  toJSON() {
    return({
      id: this.id,
      status: this.status,
      temperatureCompensationStatus: this.temperatureCompensationStatus,
      calibrationStatus: this.calibrationStatus,
      internalTemperature: this.internalTemperature,
      value: this.value
    });
  }
}

export default DissolvedOxygenSensor;